import { IsOptional, IsString, Length } from 'class-validator';

export class CollectionCreateModel {
  @Length(2, 255)
  public name: string;

  @Length(2, 255)
  public title: string;

  @IsOptional()
  @IsString()
  public description?: string;

  @Length(32, 36)
  public coverId: string;
}
